// extracted by mini-css-extract-plugin
export default {"fbIcon":"NeededStyles_fbIcon__rqTH2","googleIcon":"NeededStyles_googleIcon__ptUN0"};